module.exports = __webpack_public_path__ + "img/swift-boostergreen-banner.3dc7d804.svg";